var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb__iphone-x-left mb__iphone-x-right mb__iphone-x-bottom",attrs:{"status":"配膳"}},[_c('HOOrderListTab'),_c('HOOrderList',{attrs:{"served":_vm.servedReady}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }